export default {
  sliders: (state) => {
    return state.sliders;
  },

  blogs: (state) => {
    return state.blogs;
  },

  medias: (state) => {
    return state.medias;
  },

  sounds: (state) => {
    return state.sounds;
  },

  photos: (state) => {
    return state.photos;
  },

  books: (state) => {
    return state.books;
  },
};
